(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daelivo-product-reviews"] && !Shopify.designMode) return;
  try {
    
  class DaelivoReviewList extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.sortControl = this.querySelector('[data-daelivo-scenario-sort]');
      this.list = this.querySelector('[data-daelivo-scenario-list]');
      this.status = this.querySelector('[data-daelivo-sort-status]');
      if (this.sortControl && this.list) {
        this.sortControl.addEventListener('change', () => this.updateOrder());
      }
      this.filters = this.querySelectorAll ? [...this.querySelectorAll('[data-daelivo-note-filter]')] : [];
      this.filters.forEach((filter) => filter.addEventListener('change', () => this.updateFilters()));
      this.tabs = this.querySelectorAll ? [...this.querySelectorAll('[data-daelivo-review-tab]')] : [];
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectTab(tab)));
      this.writeToggle = this.querySelector('[data-daelivo-write-toggle]');
      this.writePanel = this.querySelector('[data-daelivo-write-panel]');
      if (this.writeToggle && this.writePanel) {
        this.writeToggle.addEventListener('click', () => this.toggleWritePanel());
      }
      this.feedbackStatus = this.querySelector('[data-daelivo-feedback-status]');
      this.feedbackButtons = this.querySelectorAll ? [...this.querySelectorAll('[data-daelivo-helpful]')] : [];
      this.feedbackButtons.forEach((button) => button.addEventListener('click', () => this.recordFeedback(button)));
    }

    updateOrder() {
      const mode = this.sortControl.value === 'routine' ? 'routine' : 'decision';
      const cards = [...this.list.querySelectorAll('[data-daelivo-editorial-scenario]')];
      const reorder = () => cards
        .sort((first, second) => Number(first.dataset[`${mode}Rank`]) - Number(second.dataset[`${mode}Rank`]))
        .forEach((card) => this.list.append(card));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (document.startViewTransition && !reduceMotion) {
        document.startViewTransition(reorder);
      } else {
        reorder();
      }
      if (this.status) {
        this.status.textContent = `${this.status.dataset.statusPrefix} ${this.sortControl.selectedOptions[0].textContent}`;
      }
    }

    updateFilters() {
      if (!this.list) return;
      const active = this.filters.filter((filter) => filter.checked).map((filter) => filter.value);
      this.list.querySelectorAll('[data-daelivo-editorial-scenario]').forEach((card) => {
        card.hidden = active.length > 0 && !active.includes(card.dataset.noteKind);
      });
    }

    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        const selected = tab === selectedTab;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      if (!this.querySelectorAll) return;
      this.querySelectorAll('[data-daelivo-review-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.daelivoReviewPanel !== selectedTab.dataset.daelivoReviewTab;
      });
    }

    toggleWritePanel() {
      const willOpen = this.writePanel.hidden;
      this.writePanel.hidden = !willOpen;
      this.writeToggle.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) this.writePanel.querySelector('a')?.focus();
    }

    recordFeedback(selectedButton) {
      const group = selectedButton.closest('[data-daelivo-helpful-group]');
      group?.querySelectorAll('[data-daelivo-helpful]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === selectedButton));
      });
      if (this.feedbackStatus) this.feedbackStatus.textContent = selectedButton.dataset.feedbackMessage;
    }
  }

  if (!customElements.get('daelivo-review-list')) customElements.define('daelivo-review-list', DaelivoReviewList);
  class DaelivoDemoReviews extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.i18n = JSON.parse(this.dataset.demoI18n || '{}');
      this.statusRegion = this.querySelector('[data-demo-status]');
      this.tabs = [...this.querySelectorAll('[data-demo-tab]')];
      this.panels = [...this.querySelectorAll('[data-demo-panel]')];
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.selectTab(tab)));
      this.bindToggle('[data-demo-filter-toggle]', '[data-demo-filter-panel]');
      this.bindToggle('[data-demo-write-toggle]', '[data-demo-write-panel]');
      this.bindToggle('[data-demo-sort-toggle]', '[data-demo-sort-panel]');
      this.bindToggle('[data-demo-media-toggle]', '[data-demo-media-panel]');
      this.filterInputs = [...this.querySelectorAll('[data-demo-filter]')];
      this.filterInputs.forEach((input) => input.addEventListener('change', () => this.applyFilters()));
      this.writeForm = this.querySelector('[data-demo-review-form]');
      this.writeForm?.addEventListener('submit', (event) => this.submitReview(event));
      this.sortOptions = [...this.querySelectorAll('[data-demo-sort-option]')];
      this.sortOptions.forEach((option) => option.addEventListener('click', () => this.applySort(option)));
      this.list = this.querySelector('[data-demo-review-list]');
      this.fetchData();
    }

    bindToggle(buttonSelector, panelSelector) {
      const button = this.querySelector(buttonSelector);
      const panel = this.querySelector(panelSelector);
      if (!button || !panel) return;
      button.addEventListener('click', () => {
        const willOpen = panel.hidden;
        panel.hidden = !willOpen;
        button.setAttribute('aria-expanded', String(willOpen));
      });
    }

    async fetchData() {
      try {
        const response = await fetch(this.dataset.demoDataUrl, { credentials: 'omit' });
        if (!response.ok) throw new Error(response.status);
        const products = await response.json();
        this.product = products.find((entry) => entry.handle === this.dataset.demoHandle);
        if (!this.product) throw new Error('missing product');
        this.render();
      } catch {
        if (this.statusRegion) this.statusRegion.textContent = 'Sample reviews unavailable.';
      }
    }

    escapeHtml(value) {
      return String(value ?? '').replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;');
    }

    starsMarkup(rating) {
      const starPath = 'M10 2.62639L8.54072 7.33639C8.34848 7.95687 7.79714 8.37696 7.17504 8.37696H2.45272L6.27316 11.2879C6.77645 11.6714 6.98704 12.3511 6.7948 12.9716L5.33552 17.6816L9.15596 14.7706C9.65925 14.3872 10.3408 14.3872 10.844 14.7706L14.6645 17.6816L13.2052 12.9716C13.013 12.3511 13.2236 11.6714 13.7268 11.2879L17.5473 8.37696H12.825C12.2029 8.37696 11.6515 7.95687 11.4593 7.33639L10 2.62639ZM10.4552 0.846855C10.3119 0.384382 9.68806 0.384382 9.54477 0.846855L7.63027 7.02616C7.56619 7.23298 7.38241 7.37301 7.17504 7.37301H0.979572C0.515888 7.37301 0.323098 7.99527 0.698226 8.28109L5.71047 12.1001C5.87823 12.2279 5.94843 12.4545 5.88435 12.6613L3.96984 18.8406C3.82656 19.3031 4.33129 19.6877 4.70642 19.4019L9.71865 15.5828C9.88642 15.455 10.1136 15.455 10.2813 15.5828L15.2936 19.4019C15.6687 19.6877 16.1734 19.3031 16.0302 18.8406L14.1157 12.6613C14.0516 12.4545 14.1218 12.2279 14.2895 12.1001L19.3018 8.28109C19.6769 7.99527 19.4841 7.37301 19.0204 7.37301H12.825C12.6176 7.37301 12.4338 7.23298 12.3697 7.02616L10.4552 0.846855Z';
      return Array.from({ length: 5 }, (_, index) => `<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"${index + 1 > rating ? ' class="is-muted"' : ''}><path d="${starPath}" fill-rule="evenodd" /></svg>`).join('');
    }

    ageInDays(age) {
      if (age === 'Just now') return 0;
      const match = String(age).match(/^(\d+)\s+(\w+)/);
      if (!match) return 999;
      const multipliers = { day: 1, days: 1, week: 7, weeks: 7, month: 30, months: 30, year: 365, years: 365 };
      return Number(match[1]) * (multipliers[match[2]] || 999);
    }

    mediaUrl(name) {
      return name ? this.dataset.demoAssetBase + name : '';
    }

    cardMarkup(review) {
      const photo = review.media
        ? `<div class="daelivo-demo-reviews__photo" data-demo-review-photo><img src="${this.mediaUrl(review.media)}" alt="Sample photo of ${this.escapeHtml(this.product.title)}"></div>`
        : '';
      return `<article data-demo-review-card data-review-rating="${review.rating}" data-review-photo="${Boolean(review.media)}" class="daelivo-demo-reviews__card${review.media ? ' daelivo-demo-reviews__card--with-photo' : ''}">
        <aside class="daelivo-demo-reviews__profile">
          <div class="daelivo-demo-reviews__reviewer"><span class="daelivo-demo-reviews__avatar" aria-hidden="true">${this.escapeHtml(review.initials)}</span><div><strong>${this.escapeHtml(review.name)}</strong><span class="daelivo-demo-reviews__verified">${this.escapeHtml(this.i18n.sample_badge)}</span></div></div>
          <p class="daelivo-demo-reviews__reviewing"><span>${this.escapeHtml(this.i18n.reviewing)}</span><strong>${this.escapeHtml(review.productName)}</strong></p>
          <p class="daelivo-demo-reviews__intent">${this.escapeHtml(this.i18n.recommend_this)}</p>
          <dl class="daelivo-demo-reviews__attributes">
            <div><dt>${this.escapeHtml(this.i18n.liked_q)}</dt><dd>${this.escapeHtml(review.liked)}</dd></div>
            <div><dt>${this.escapeHtml(this.i18n.recommend_q)}</dt><dd>${review.recommended ? this.escapeHtml(this.i18n.yes) : this.escapeHtml(this.i18n.no)}</dd></div>
          </dl>
        </aside>
        <div class="daelivo-demo-reviews__body">
          <div class="daelivo-demo-reviews__meta"><span class="daelivo-demo-reviews__stars" role="img" aria-label="${review.rating} ${this.escapeHtml(this.i18n.stars_aria)}">${this.starsMarkup(review.rating)}</span><span data-review-age="${this.escapeHtml(review.age)}">${this.escapeHtml(review.age)}</span></div>
          <h3 class="daelivo-demo-reviews__headline">${this.escapeHtml(review.headline)}</h3>
          <p>${this.escapeHtml(review.body)}</p>
          <div class="daelivo-demo-reviews__footer"><span>${this.escapeHtml(this.i18n.helpful_q)}</span><button type="button" data-demo-helpful>${this.escapeHtml(this.i18n.yes)} (${review.helpful})</button><button type="button" data-demo-helpful>${this.escapeHtml(this.i18n.no)} (${review.unhelpful})</button></div>
        </div>
        ${photo}
      </article>`;
    }

    render() {
      const product = this.product;
      this.querySelectorAll('[data-demo-count], [data-demo-count-copy]').forEach((node) => { node.textContent = product.count.toLocaleString('en-US'); });
      this.querySelectorAll('[data-demo-rating]').forEach((node) => { node.textContent = product.rating.toFixed(1); });
      this.querySelectorAll('[data-demo-recommend]').forEach((node) => { node.textContent = `${product.recommend}%`; });
      const stars = this.querySelector('[data-demo-stars]');
      if (stars) {
        stars.setAttribute('aria-label', `${product.rating.toFixed(1)} ${this.i18n.stars_aria}`);
        stars.innerHTML = this.starsMarkup(product.rating);
      }
      this.querySelectorAll('[data-demo-distribution]').forEach((bar, index) => { bar.style.width = `${product.distribution[index]}%`; });
      this.querySelectorAll('[data-demo-distribution-copy]').forEach((copy, index) => { copy.textContent = `${product.distribution[index]}%`; });
      const galleryImages = [...this.querySelectorAll('[data-demo-gallery-image]')];
      galleryImages.forEach((image, index) => {
        const mediaIndex = index % product.media.length;
        image.src = this.mediaUrl(product.media[mediaIndex]);
        image.alt = `Sample photo ${mediaIndex + 1} of ${product.title}`;
        image.hidden = false;
      });
      this.querySelectorAll('[data-demo-review-list]').forEach((list) => { list.innerHTML = product.reviews.map((review) => this.cardMarkup(review)).join(''); });
      this.bindHelpful();
      this.applyFilters();
    }

    bindHelpful() {
      this.querySelectorAll('[data-demo-helpful]').forEach((button) => button.addEventListener('click', () => {
        button.parentElement.querySelectorAll('[data-demo-helpful]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        if (this.statusRegion) this.statusRegion.textContent = this.i18n.feedback_thanks;
      }));
    }

    visibleCards() {
      return [...this.querySelectorAll('[data-demo-review-card]')];
    }

    applyFilters() {
      const fiveOnly = this.querySelector('[data-demo-filter="five"]')?.checked;
      const photosOnly = this.querySelector('[data-demo-filter="photos"]')?.checked;
      let visible = 0;
      this.visibleCards().forEach((card) => {
        const matches = (!fiveOnly || Number(card.dataset.reviewRating) === 5) && (!photosOnly || card.dataset.reviewPhoto === 'true');
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      const status = this.querySelector('[data-demo-filter-status]');
      if (status) status.textContent = `${visible} ${this.i18n.shown_suffix}`;
    }

    applySort(option) {
      const mode = option.dataset.demoSortOption;
      const cards = this.visibleCards();
      const sorters = {
        newest: (a, b) => this.ageInDays(a.dataset.reviewAge) - this.ageInDays(b.dataset.reviewAge),
        oldest: (a, b) => this.ageInDays(b.dataset.reviewAge) - this.ageInDays(a.dataset.reviewAge),
        highest: (a, b) => Number(b.dataset.reviewRating) - Number(a.dataset.reviewRating),
        lowest: (a, b) => Number(a.dataset.reviewRating) - Number(b.dataset.reviewRating),
      };
      cards.sort(sorters[mode] || sorters.newest).forEach((card) => card.parentElement?.append(card));
      const label = this.querySelector('[data-demo-sort-label]');
      if (label) label.textContent = option.textContent;
      if (this.statusRegion) this.statusRegion.textContent = `${this.i18n.sort_status_prefix || 'Sorted:'} ${option.textContent}`;
    }

    submitReview(event) {
      event.preventDefault();
      if (!this.product) return;
      const formData = new FormData(this.writeForm);
      const name = String(formData.get('name') || 'Sample viewer').trim();
      this.product.reviews.unshift({
        initials: name.split(/\s+/).map((part) => part[0]).join('').slice(0, 2).toUpperCase() || 'SV',
        name,
        verification: this.i18n.sample_badge,
        headline: String(formData.get('headline') || ''),
        rating: Number(formData.get('rating') || 5),
        age: this.i18n.just_now,
        body: String(formData.get('body') || ''),
        liked: this.i18n.submitted_liked,
        productName: this.product.title,
        recommended: true,
        helpful: 0,
        unhelpful: 0,
        media: '',
      });
      this.product.count += 1;
      this.render();
      this.writeForm.reset();
      const status = this.querySelector('[data-demo-form-status]');
      if (status) status.textContent = this.i18n.submitted_status;
    }

    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        const selected = tab === selectedTab;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.demoPanel !== selectedTab.dataset.demoTab; });
    }
  }

  if (!customElements.get('daelivo-demo-reviews')) customElements.define('daelivo-demo-reviews', DaelivoDemoReviews);

  } catch(e) { console.error(e); }
})();
})();
